import Typography from '@mui/material/Typography';
import { FC } from 'react';

interface AccessibilityHiddenHeaderProps {
  title: string;
}

const AccessibilityHiddenHeader: FC<AccessibilityHiddenHeaderProps> = ({
  title,
}) => {
  return <Typography aria-label={title} />;
};

export default AccessibilityHiddenHeader;
